export default __webpack_public_path__ + "static/media/Binger-search.7d2f54ec.png";